import { BenefitType } from "../enums/BenefitType";
import { Relationship } from "../enums/Relationship";
import { Party } from "../enums/Party";
import { GenericRelationship } from "../enums/GenericRelationship";

export type FormValues = {
    claimId: string,
    claimNumber: string,
    claimNumbers: string[],
    benefit: BenefitType,
    party: Party,
    eConsent: boolean,
    eConsentContinue: boolean,
    disability: boolean,
    pfml: boolean,
    life: boolean,
    hospitalIndemnity: boolean,
    accident: boolean,
    wellness: boolean,
    criticalIllness: boolean,
    deceased: string,
    takingLeave: string,
    earningsLoss: string,
    genericRelationship: GenericRelationship,
    relationship: Relationship,
    firstName: string,
    lastName: string,
    useEnteredAddress: boolean,
    medicalRelated: boolean,
    defaultDocumentType: string,
    summaryContent: string,
    incompleteIntakeEmailAddress: string,
    incompleteIntakePassword: string,
    currentStep: string,
    formKey: string,
    fraudConsent: boolean,
}

export const defaultFormValues = {
    claimId: '',
    claimNumber: '',
    claimNumbers: [],
    benefit: '',
    party: '',
    eConsent: false,
    eConsentContinue: false,
    disability: false,
    pfml: false,
    life: false,
    hospitalIndemnity: false,
    accident: false,
    wellness: false,
    criticalIllness: false,
    deceased: '',
    takingLeave: '',
    earningsLoss: '',
    genericRelationship: '' as GenericRelationship,
    relationship: '' as Relationship,
    firstName: '',
    lastName: '',
    useEnteredAddress: false,
    medicalRelated: false,
    defaultDocumentType: '',
    summaryContent: '',
    incompleteIntakeEmailAddress: '',
    incompleteIntakePassword: '',
    currentStep: '',
    formKey: '',
    fraudConsent: false,
}